import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import LocalStorage from '../../utils/localStorage';

const shoppingPendingOrderKey = 'Pending_Shopping_';

class shoppingStore {

    // Main Properties

    @observable menu = null;
    @observable shoppingItems = [];
    @observable shoppingFilterItems = [];
    @observable shoppingPendingOrders = [];
    @observable shoppingRemark = '';
    @observable shoppingSearchText = '';
    @observable shoppingSearchSubCategory = 'All';
    @observable shoppingTotalOrder = 0;

    // Shopping Detail Modal

    @observable shoppingDetail = null;
    @observable showShoppingDetailModal = false;

    // Shopping Tab

    @observable shoppingTabLoading = false;
    @observable shoppingTabCategories = [];
    @observable shoppingTabSubCategories = [];
    @observable shoppingTabCategoryIdActive = '0';

    // Shopping Confirm

    @observable shoppingSubTotal = 0;
    @observable shoppingVat = 0;
    @observable shoppingVatTax = 0;
    @observable shoppingServiceFee = 0;
    @observable shoppingServiceFeeTax = 0;
    @observable shoppingTotal = 0;

    @observable shoppingTimeSelected = 'now';
    @observable shoppingTimeDeliver = '';
    @observable shoppingTimeDeliverDate = '';

    @observable shoppingPaymentOption = 'Cash';

    // Swipe
    @observable swipeX = 0;
    @observable isSwipe = false;

    // Initialization

    @action initGetShoppings(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getShoppings(languageCode).then((shoppingResponses) => {
            if (shoppingResponses) {
                that.menu = shoppingResponses.menu;
                that.shoppingTabCategories = shoppingResponses.categoryNames;
                that.shoppingTabSubCategories = that.shoppingTabCategories[0].subCategories;

                if (that.shoppingTabCategoryIdActive === '0') {
                    that.shoppingTabCategoryIdActive = that.shoppingTabCategories[0].taskId.toString();
                }

                that.shoppingItems = shoppingResponses.items;
                that.shoppingFilterItems = that.shoppingItems;

                if (that.shoppingFilterItems.length > 0) {
                    that.shoppingFilterItems.map((shoppingItem) => {
                        return shoppingItem.orderQuantity = 0;
                    });

                    const shoppingOrders = this.getShoppingPendingOrdersFromStorage(roomNo);
                    if (shoppingOrders !== null) {
                        shoppingOrders.map((shoppingOrder) => {
                            let shoppingItem = that.shoppingFilterItems.find(it => it.taskId === shoppingOrder.taskId);
                            if (shoppingItem) {
                                shoppingItem.orderQuantity = shoppingOrder.orderQuantity;
                            }
                            return shoppingItem;
                        })
                    }
                }
            } else {
                that.menu = null;
                that.shoppingTabCategories = [];
                that.shoppingTabSubCategories = [];
                that.shoppingItems = [];
                that.shoppingFilterItems = [];
                that.shoppingSearchText = '';
                that.shoppingSearchSubCategory = 'All';
            }

            this.searchShoppingByNameAndSubCategory();
        });
    }

    @action refreshShoppings(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getShoppings(languageCode).then((shoppingResponses) => {
            if (shoppingResponses) {
                that.menu = shoppingResponses.menu;
                that.shoppingTabCategories = shoppingResponses.categoryNames;
                that.shoppingTabSubCategories = that.shoppingTabCategories[0].subCategories;

                if (that.shoppingTabCategoryIdActive === '0') {
                    that.shoppingTabCategoryIdActive = that.shoppingTabCategories[0].taskId.toString();
                }

                that.shoppingItems = shoppingResponses.items;
                that.shoppingFilterItems = that.shoppingItems;

                if (that.shoppingFilterItems.length > 0) {
                    that.shoppingFilterItems.map((shoppingItem) => {
                        return shoppingItem.orderQuantity = 0;
                    });

                    const shoppingOrders = this.getShoppingPendingOrdersFromStorage(roomNo);
                    if (shoppingOrders !== null) {
                        shoppingOrders.map((shoppingOrder) => {
                            let shoppingItem = that.shoppingFilterItems.find(it => it.taskId === shoppingOrder.taskId);
                            if (shoppingItem) {
                                shoppingItem.orderQuantity = shoppingOrder.orderQuantity;
                            }
                            return shoppingItem;
                        })
                    }
                }
            } else {
                that.menu = null;
                that.shoppingTabCategories = [];
                that.shoppingTabSubCategories = [];
                that.shoppingItems = [];
                that.shoppingFilterItems = [];
                that.shoppingSearchText = '';
                that.shoppingSearchSubCategory = 'All';
            }

            this.searchShoppingByNameAndSubCategory();
        });
    }

    @action initShoppingConfirm(roomNo) {
        this.shoppingRemark = '';
        this.shoppingTimeSelected = 'now';
        this.shoppingTimeDeliver = '';

        let data = LocalStorage.Get(shoppingPendingOrderKey + roomNo);
        if (data !== null) {
            this.shoppingPendingOrders = data;
        }

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getShopping(languageCode).then(resp => {
            this.menu = resp;

            this.shoppingVatTax = resp.vat;
            this.shoppingServiceFeeTax = resp.serviceFee;

            this.setShoppingPriceDetail();
        });
    }

    @action initTotalShoppingOrder(roomNo) {
        const orders = LocalStorage.Get(shoppingPendingOrderKey + roomNo);

        if (orders) {
            let quantity = 0;
            orders.map(order => {
                quantity = quantity + order.orderQuantity;

                return order;
            });

            this.shoppingTotalOrder = quantity;
        } else {
            this.shoppingTotalOrder = 0;
        }
    }

    // Transaction Action

    @action goToShoppingConfirmPage(roomNo) {
        let items = this.shoppingItems.filter(item => item.orderQuantity > 0);
        LocalStorage.Save(shoppingPendingOrderKey + roomNo, items);
        return LocalStorage.Get(shoppingPendingOrderKey + roomNo);
    }

    @action goToShoppingConfirmPageFromRetailOffer(roomNo, taskId) {
        return this.refreshShoppings(roomNo).then(() => {
            let item = this.shoppingItems.find(item => item.taskId === taskId);
            item.orderQuantity = item.orderQuantity + 1;
            let items = this.shoppingItems.filter(item => item.orderQuantity > 0);
            LocalStorage.Save(shoppingPendingOrderKey + roomNo, items);
            LocalStorage.Get(shoppingPendingOrderKey + roomNo);
        });
    }

    @action removeShoppingOrders(roomNo) {
        this.shoppingItems = [];
        this.shoppingFilterItems = this.shoppingItems;
        LocalStorage.Remove(shoppingPendingOrderKey + roomNo);
    }

    @action backToShoppingMainPage(roomNo) {
        const shoppingPendingOrders = this.shoppingPendingOrders.filter(item => item.orderQuantity > 0);

        if (shoppingPendingOrders) {
            LocalStorage.Save(shoppingPendingOrderKey + roomNo, shoppingPendingOrders);
        } else {
            LocalStorage.Save(shoppingPendingOrderKey + roomNo, []);
        }
    }

    // GET Properties

    @action getShoppingsByTaskId(taskId) {
        const shoppingItem = this.shoppingItems.find(it => it.taskId === taskId);

        this.shoppingDetail = shoppingItem;
        this.showShoppingDetailModal = true;

        return shoppingItem;
    }

    @action getShoppingPendingOrders() {
        return this.shoppingPendingOrders.filter(it => it.orderQuantity > 0);
    }

    @action getShoppingPendingOrdersFromStorage(roomNo) {
        return LocalStorage.Get(shoppingPendingOrderKey + roomNo);
    }

    // Set Properties

    @action setShoppingRemark(value) {
        this.shoppingRemark = value;
    }

    @action setShoppingItemQty(taskId, value) {
        const shoppingItem = this.shoppingItems.find(it => it.taskId === taskId);
        shoppingItem.orderQuantity = value;

        let quantity = 0;

        this.shoppingItems.map(item => {
            quantity = quantity + item.orderQuantity;
            return item;
        });

        this.shoppingTotalOrder = quantity;
    }

    @action setShoppingPendingOrderQty(taskId, value) {
        const shoppingPendingOrder = this.shoppingPendingOrders.find(it => it.taskId === taskId);
        shoppingPendingOrder.orderQuantity = value;

        this.setShoppingPriceDetail();
    }

    @action setShowShoppingDetailModal(value) {
        this.showShoppingDetailModal = value;
    }

    @action setShoppingPriceDetail() {
        this.shoppingSubTotal = 0;

        this.shoppingPendingOrders.map((order) => {
            if (order.price === order.specialPrice) {
                this.shoppingSubTotal = this.shoppingSubTotal + (order.orderQuantity * order.price);
            } else {
                this.shoppingSubTotal = this.shoppingSubTotal + (order.orderQuantity * order.specialPrice);
            }

            return this.shoppingSubTotal;
        });

        this.shoppingVat = this.shoppingSubTotal * this.shoppingVatTax / 100;
        this.shoppingServiceFee = this.shoppingSubTotal * this.shoppingServiceFeeTax / 100;
        this.shoppingTotal = this.shoppingVat + this.shoppingServiceFee + this.shoppingSubTotal;
    }

    @action setShoppingTimeSelected(value) {
        this.shoppingTimeSelected = value;
        this.shoppingTimeDeliver = '';
    }

    @action setShoppingTimeDeliver(value) {
        this.shoppingTimeDeliver = value;
        this.shoppingTimeSelected = '';
    }

    @action setShoppingTimeDeliverDate(value) {
        this.shoppingTimeDeliverDate = value;
    }

    @action searchShoppingByNameAndSubCategory() {
        if (this.shoppingSearchText === '' && this.shoppingSearchSubCategory === 'All') {
            this.shoppingFilterItems = this.shoppingItems;
            return;
        }

        if (this.shoppingSearchSubCategory === 'All') {
            this.shoppingFilterItems = this.shoppingItems;
        } else {
            this.shoppingFilterItems = this.shoppingItems.filter(item => {
                let subCategoryName = item.subCategoryName.toLowerCase();
                return subCategoryName.indexOf(this.shoppingSearchSubCategory.toLowerCase()) !== -1;
            });
        }

        if (this.shoppingSearchText !== '') {
            this.shoppingFilterItems = this.shoppingFilterItems.filter(item => {
                let itemTaskName = item.taskName.toLowerCase();
                return itemTaskName.indexOf(this.shoppingSearchText.toLowerCase()) !== -1;
            });
        }
    }

    @action setShoppingSearchText(value) {
        this.shoppingSearchText = value;
    }

    @action setShoppingSearchSubCategory(value) {
        this.shoppingSearchSubCategory = value;
    }

    @action setShoppingTabSubCategoriesByTabCategoryTaskId(tabCategoryTaskId) {
        this.shoppingTabCategoryIdActive = tabCategoryTaskId.toString();
        const category = this.shoppingTabCategories.find(fi => fi.taskId === parseInt(tabCategoryTaskId));

        if (category) {
            if (category.subCategories.length > 0) {
                this.shoppingTabSubCategories = category.subCategories;
                return;
            }
        }

        this.shoppingTabSubCategories = [];
    }

    @action setShoppingPaymentOption(value) {
        this.shoppingPaymentOption = value;
    }

    @action setSwipeX(value) {
        this.swipeX = value;
    }

    @action setIsSwipe(value) {
        this.isSwipe = value;
    }

    // RESET Properties

    @action resetData() {
        this.menu = null;
        this.showShoppingDetailModal = false;
        this.shoppingTabCategories = [];
        this.shoppingTabSubCategories = [];
        this.shoppingItems = [];
        this.shoppingFilterItems = this.shoppingItems;
        this.shoppingSearchText = '';
        this.shoppingSearchSubCategory = 'All';
        this.searchShoppingByNameAndSubCategory();
    }
}

export default new shoppingStore()